
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import CareersSection from "@/components/CareersSection";
import Seo from "@/components/Seo";
import {
  buildBreadcrumbJsonLd,
  buildCanonicalUrl,
  buildWebPageJsonLd,
  organizationJsonLd,
  websiteJsonLd,
} from "@/lib/seo";

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Careers at Travel Wings Global | Join the Team"
        description="Explore career opportunities at Travel Wings Global across travel, forex, and customer success."
        path="/careers"
        structuredData={[
          organizationJsonLd,
          websiteJsonLd,
          buildWebPageJsonLd({
            name: "Careers at Travel Wings Global | Join the Team",
            description:
              "Career opportunities at Travel Wings Global across travel, forex, and customer success.",
            url: buildCanonicalUrl("/careers"),
            type: "CollectionPage",
          }),
          buildBreadcrumbJsonLd([
            { name: "Home", url: buildCanonicalUrl("/") },
            { name: "Careers", url: buildCanonicalUrl("/careers") },
          ]),
        ]}
      />
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-b from-green-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Join Our <span className="text-green-600">Team</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Build your career with Travel Wings and be part of our growing success story
          </p>
        </div>
      </section>

      {/* Careers Content */}
      <CareersSection />

      <Footer />
    </div>
  );
}